import { useState } from 'react';
import { usedictionaries } from '../../../../entities/dictionaries';
import type { OrganizationDocumentsFiltersValue } from '../../lib/filtertypes';
import { OrganizationDocumentsFilters } from './filters';
import { OrganizationDocumentsList } from './list';

export const OrganizationDocumentsTab = () => {
  const { organizationDocumentTypeOptions } = usedictionaries();
  const [filters, setFilters] = useState<OrganizationDocumentsFiltersValue>({
    period: 'all',
  });

  return (
    <div className="flex flex-col gap-6 pt-4">
      <div className="p-4 bg-white -mb-1 rounded-lg border border-gray-200">
        <OrganizationDocumentsFilters
          value={filters}
          onChange={setFilters}
          documentTypeOptions={organizationDocumentTypeOptions}
        />
      </div>
      <OrganizationDocumentsList filters={filters} />
    </div>
  );
};
